import { FormLabel, Heading, Text } from '@chakra-ui/react';
import { getTextFromPreviousAnswer } from '../../handlers/utils';

const ElementHeading = ({ qObj, props }) => {
  let question = qObj.question;
  const stateProps = props.stateProps;
  const sectionName = stateProps.sectionData.sectionName
  let required = qObj.is_required ? <Text as="span" fontWeight={600} fontSize="14px" color="RED"> *</Text> : null;
  const id = qObj.id;

  if (typeof question === 'undefined') {
    return null;
  } else {
    question = getTextFromPreviousAnswer(question, props);
    if ( qObj.question_type !== 'multipart' && typeof qObj.mpparent === 'undefined') {
      return (
        <FormLabel htmlFor={id} sx={{ marginBottom: ['4px', null, '8px'], padding: 0 }}>
          <Heading variant='elementHeading' >{question}</Heading>
        </FormLabel>
      );
    } else {
      return (
        <FormLabel htmlFor={id} sx={{ margin: 0, padding: 0 }}>
          { sectionName === 'resumes' || sectionName === 'parser' ? (
            <Heading variant="sectionHeading">{question}</Heading>
          ) : (
            <Text fontSize={'16px'} color="BLACK" paddingTop={['8px']}>{question}{required}</Text>
          )}
        </FormLabel>
      );
    }
  }
};

export default ElementHeading;
